import React, { useCallback } from 'react'
import { isNil, noop } from 'lodash'
import styled from '@emotion/styled'
import { NegotiationPackageDetail } from 'api'
import { TypedCellRendererParams } from 'view/components/datagrid'
import { useCurveGridSelectionContext } from './CurveGridSelectionContext'
import { Checkbox } from 'view/components/inputs'
import * as mixins from 'view/styles/mixins'

const CheckboxContainer = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  height: 100%;
  padding-left: 10px;
`
const DisabledCheckboxContainer = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  height: 100%;
  > button {
    cursor: none;
    background: #f2f2f2;
  }
`

export const DisabledSelector: React.FC = () => (
  <DisabledCheckboxContainer>
    <Checkbox isChecked={false} onUpdate={noop} disabled={true} />
  </DisabledCheckboxContainer>
)

export const CurveNegotiationSelectorRenderer = React.forwardRef<Checkbox, TypedCellRendererParams<NegotiationPackageDetail>>(
  (props, ref) => {
    const { node, data } = props
    const { onNegotiationSelected, isNegotiationSelected } = useCurveGridSelectionContext()

    const negotiation = data?.negotiation

    const isSelected = !!negotiation && isNegotiationSelected(negotiation)

    const onUpdate = useCallback(() => {
      if (!negotiation) return
      return onNegotiationSelected(negotiation.negotiationId, !isSelected)
    }, [negotiation, isSelected, onNegotiationSelected])

    if (isNil(negotiation) || !!node.group || isNil(negotiation.negotiationId)) {
      return null
    }

    return (
      <CheckboxContainer>
        <Checkbox isChecked={isSelected} onUpdate={onUpdate} ref={ref} />
      </CheckboxContainer>
    )
  }
)
